export function allReceipts(state) {
  const cats = Object.fromEntries(state.categories.map((c) => [c.id, c.name]));
  const attached = state.transactions.flatMap((t) => (t.receipts || []).map((m) => ({ key: m.id, meta: m, tx: t, store: m.store || "", title: t.description, amount: Math.abs(t.amount), date: t.date, note: [m.note, t.notes].filter(Boolean).join(" · "), category: cats[t.category] || t.category || "" })));
  const inbox = (state.receiptInbox || []).map((r) => ({ key: r.id, meta: r, tx: null, store: r.store || "", title: r.store || r.name, amount: Math.abs(Number(r.amount)) || null, date: r.date || r.addedAt?.slice(0, 10), note: r.note || "", category: "" }));
  return [...attached, ...inbox].sort((a, b) => String(b.date).localeCompare(String(a.date)));
}

// Words must all appear in store/description/note/category/file; numbers also match the amount
export function searchReceipts(list, q) {
  const words = q.toLowerCase().replace(/[$,]/g, "").split(/\s+/).filter(Boolean);
  if (!words.length) return list;
  return list.filter((r) => {
    const hay = [r.store, r.title, r.note, r.category, r.meta.name, r.date].join(" ").toLowerCase();
    const amt = r.amount != null ? r.amount.toFixed(2) : "";
    return words.every((w) => hay.includes(w) || (/^\d+(\.\d*)?$/.test(w) && (amt === Number(w).toFixed(2) || amt.startsWith(w))));
  });
}

export const inRange = (date, from, to) => !!(!from || (date && date >= from)) && (!to || (date && date <= to));

export const filterReceipts = (list, f) => searchReceipts(list.filter((r) => (f.where === "all" || !f.where || (f.where === "attached" ? r.tx : !r.tx)) && inRange(r.date, f.from, f.to)), f.q || "");

// Each transaction's amount counts once, however many receipts it has; inbox receipts add their own amount
export function receiptTotals(found) {
  const tx = new Map();
  let inbox = 0;
  found.forEach((r) => (r.tx ? tx.set(r.tx.id, Math.abs(r.tx.amount)) : (inbox += r.amount || 0)));
  const total = Math.round(([...tx.values()].reduce((s, a) => s + a, 0) + inbox) * 100) / 100;
  return { receipts: found.length, transactions: tx.size, total };
}
// Monthly totals (each transaction counted once per month)
export function monthlyTrend(found) {
  const by = {};
  found.forEach((r) => {
    const m = (r.date || "").slice(0, 7);
    if (m) (by[m] ||= []).push(r);
  });
  const months = Object.keys(by).sort();
  if (!months.length) return [];
  const out = [];
  for (let [y, mo] = months[0].split("-").map(Number); `${y}-${String(mo).padStart(2, "0")}` <= months[months.length - 1]; mo === 12 ? (y++, (mo = 1)) : mo++) {
    const key = `${y}-${String(mo).padStart(2, "0")}`;
    const rs = by[key] || [];
    const tx = new Map();
    let inbox = 0;
    rs.forEach((r) => (r.tx ? tx.set(r.tx.id, Math.abs(r.tx.amount)) : (inbox += r.amount || 0)));
    out.push({ month: key, total: Math.round(([...tx.values()].reduce((s, a) => s + a, 0) + inbox) * 100) / 100, count: rs.length });
  }
  return out;
}
